module.exports = __webpack_public_path__ + "assets/img/johannes-plenio-fmTde1Fe23A-unsplash_cutted.9d2a9de5.jpg";